export const horrairesConstants = {
    HORRAIRE_LOADING: 'HORRAIRE_LOADING',
    POSTHORRAIRE_SUCCESS: 'POST_HORRAIRE_SUCCESS',
    POSTHORRAIRE_FAILURE: 'POST_HORRAIRE_FAILURE',
    GETHORRAIRES_SUCCESS: 'GET_HORRAIRES_SUCCESS',
    GETHORRAIRES_FAILURE: 'GET_HORRAIRES_FAILURE',
    DELETEHORRAIRE_SUCCESS: 'DELETE_HORRAIRE_SUCCESS',
    DELETEHORRAIRE_FAILURE: 'DELETE_HORRAIRE_FAILURE',
}
